import { render, staticRenderFns } from "./addTraderDialog.vue?vue&type=template&id=49b130d6&scoped=true"
import script from "./addTraderDialog.vue?vue&type=script&lang=js"
export * from "./addTraderDialog.vue?vue&type=script&lang=js"
import style0 from "./addTraderDialog.vue?vue&type=style&index=0&id=49b130d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b130d6",
  null
  
)

export default component.exports